import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseResponse, ActivityResponse, Activity, ActivityTypeResponse } from "../core/core.component";
import { Http, Headers, URLSearchParams} from '@angular/http'; 
import { AppConstants } from '../core/app.constants';
import { ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { environment } from 'environments/environment';

@Injectable()
export class ActivityService 
{

  private activityDetailStatus = new Subject<Activity>();
    
  constructor(private http: Http, private datePipe: DatePipe) { }
  
 // servizi per interazione componenti
  
  getActivityDetailStatus() : Observable<Activity> {
      return this.activityDetailStatus.asObservable();
  }
  
  openActivityDetail(activity: Activity) {
      this.activityDetailStatus.next(activity);
  }

  closeActivityDetail() {
      this.activityDetailStatus.next();
  }
  
  // Call REST
  
  search(srmToken, dateFrom: Date, dateTo: Date, userId: number, issuesId: number[]): Observable<ActivityResponse> 
  {
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues/activities";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      
      let params: URLSearchParams = new URLSearchParams();
      params.set('from', this.datePipe.transform(dateFrom, "yyyy-MM-dd"));
      params.set('to', this.datePipe.transform(dateTo, "yyyy-MM-dd"));
      params.set('asReport', "false");
      if(userId != null && userId != 0) {
          params.set('userId', userId.toString());
      }
      if(issuesId != null && issuesId.length != 0)
      {
          let s = "";
          for(let i = 0; i < issuesId.length; ++i) {
              if(i != 0) {
                  s += ",";
              }
              s += issuesId[i];
          }
          params.set('issueId', s);
      }
      return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }
  
  reportActivities(srmToken, dateFrom: Date, dateTo: Date) : Observable<any>
  {
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/issues/activities";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      
      let params: URLSearchParams = new URLSearchParams();
      params.set('from', this.datePipe.transform(dateFrom, "yyyy-MM-dd"));
      params.set('to', this.datePipe.transform(dateTo, "yyyy-MM-dd"));
      params.set('asReport', "true");
     
      return this.http.get(url, {search: params, headers: headers, responseType: ResponseContentType.Blob}).map(res => res.blob());
  }
  
  getAcivityTypes(srmToken): Observable<ActivityTypeResponse> 
  {
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/activitytypes";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
     
      return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }
  
  createActivity(srmToken, issueId: number, date: Date, hours: number, minutes: number, typeId: number, comment: string):
  Observable<ActivityResponse> 
  {
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/activity/create";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      headers.append("Content-Type", "application/json; charset=UTF-8");
      let  body = {date:  this.datePipe.transform(date, "yyyy-MM-dd"), 
                   issueId: issueId,
                   hours: hours, 
                   minutes: minutes,
                   activityTypeId: typeId,
                   comment: comment};
      
      return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
  }
  
  updateActivity(srmToken, idActivity: number, issueId: number, date: Date, hours: number, minutes: number, typeId: number, comment: string):
  Observable<BaseResponse> 
  {
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/activity/" + idActivity;
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      headers.append("Content-Type", "application/json; charset=UTF-8");
      let  body = {date:  this.datePipe.transform(date, "yyyy-MM-dd"), 
                   issueId: issueId,
                   hours: hours, 
                   minutes: minutes,
                   activityTypeId: typeId,
                   comment: comment};
      
      return this.http.put(url, body , {headers: headers}).map((responseData) => responseData.json());
  }
 
  deleteActivity(srmToken, idActivity: number, issueId: number): Observable<BaseResponse> 
  {  
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/activity/" + idActivity + "/" + issueId;
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      
      return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
  }

  moveActivity(srmToken, idActivity: number, toIssueId: number): Observable<BaseResponse> 
  {  
      var url = environment.REST_SERVICE_BASE_URL + "/tbg/activity/" + idActivity + "/move";
      url = AppConstants.urlForNoCache(url);
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      let params: URLSearchParams = new URLSearchParams();
      params.set('issueId', toIssueId+"");
      return this.http.post(url, {}, {search: params, headers: headers}).map((responseData) => responseData.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/activity.service.ts